import React from 'react';
import { Buckets } from '../../models/buckets-enum';
import { IAuthorizationProps } from './authorization-props';

interface IBucketFlaggedProps extends IAuthorizationProps {
    buckets: Buckets[];
    children: JSX.Element;
}

const BucketFlagged = ({ buckets, children, session }: IBucketFlaggedProps) => {
    return <>{session.buckets.some((r) => buckets.includes(r)) && children}</>;
};

export default BucketFlagged;
